import accordion from "./modules/accordion";
import inviewAnim from "./modules/inview";
import setMaronryLayout from "./modules/masonry";
import setMvAnim from "./modules/setMvAnim";
import forLowerLayerSlide from "./modules/forLowerLayerSlide";
import globalNav from "./modules/global-nav";
import recruit from "./modules/recruit";
import setModal from "./modules/modal";
import sustainability from "./modules/sustainability";
import setSearch from "./modules/setSearch";
import setNewsDetailMovie from "./modules/setNewsDetailMovie";
import setPrivacyCheck from "./modules/setPrivacyCheck";
import setHeaderFixed from "./modules/setHeaderFixed";
import pageTop from "./modules/setPageTop";

window.addEventListener('load', () => {
  document.querySelector('body').classList.remove('preload');

  if(document.querySelector('body').classList.contains('is-top')) {
    setMvAnim();
  }

  forLowerLayerSlide();
  inviewAnim();
  globalNav();
  // setNewsItem();
  setModal();
  setSearch();
  setMaronryLayout();
  setNewsDetailMovie();
  setPrivacyCheck();
  setHeaderFixed();
  pageTop();
})
accordion()
recruit()
sustainability()